import React from 'react';
import type { ModelDefinition } from '../../utils/api';
import { getCategoryIconName, getModelIconName, modelIconUrl } from '../../utils/modelIcons';
import './ModelIcon.css';

interface ModelIconProps {
  model?: string;
  categoryId?: string;
  models?: ModelDefinition[];
  size?: number;
  className?: string;
}

const ModelIcon: React.FC<ModelIconProps> = ({ model, categoryId, models = [], size = 20, className = '' }) => {
  const iconName = categoryId
    ? getCategoryIconName(categoryId, models)
    : getModelIconName(model || '');
  const url = modelIconUrl(iconName);
  return (
    <span
      className={`model-icon${className ? ` ${className}` : ''}`}
      style={{
        width: size,
        height: size,
        WebkitMaskImage: `url("${url}")`,
        maskImage: `url("${url}")`,
      }}
      aria-hidden="true"
    />
  );
};

export default ModelIcon;
